export const getPropsJson = (element: Element): {} => {
  const el = element.querySelector('[data-props]');

  if (!el) {
    return {};
  }

  const data = el.innerHTML;

  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
};
